module.exports = "\n\n.card-content\n{\n    text-align: center;\n}\n\n.card .card-content p \n{\n    text-align: center;\n}"